import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './ChildPhoneCard.module.scss';
import Avatar from '@shared/Avatar/Avatar';
import classNames from 'classnames/bind';
const defaultAvatarSrc = '/images/banner/avatar.svg';
const ChildPhoneCard = ({ phone, title, className, titleClasses, phoneClasses, avatar }) => {
    const avatarSrc = avatar || defaultAvatarSrc;
    const phoneBlockClasses = classNames(classes.phone, phoneClasses, {
        [titleClasses || '']: !title,
    });
    return (_jsxs("div", { className: classNames(classes.phoneBlock, className), children: [_jsx(Avatar, { picture: avatarSrc, className: classes.avatar }), _jsxs("p", { className: classes.phoneWrap, children: [title && _jsx("span", { className: classNames(classes.text, titleClasses), children: title }), _jsx("span", { className: phoneBlockClasses, children: phone })] })] }));
};
export default ChildPhoneCard;
